if(!customElements.get('custom-image-banner')){
    class CustomImageBanner extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.video = this.querySelector('video');
            if(this.video){
                this.video.addEventListener('loadeddata', (e) => {
                    this.video.classList.add('loaded');
                })
                if (this.video.readyState >= 2) {
                    this.video.classList.add('loaded');
                }
            }
        }
    }

    customElements.define('custom-image-banner', CustomImageBanner);
}